<template>
    <!-- Benefit Start -->
    <section id="benefit" class="bg-primary jargen6 py-5 overflow-hidden">
        <div class="container">
            <div class="row">
                <div class="col-12 my-5 d-block"><h3 class="text-title-content text-white wow slideInDown">{{SectionBenefit.title}}<br>{{SectionBenefit.title2}}</h3></div>
                <!-- <div class="col-2"><div class="jargen6 wow slideInRight"></div></div> -->
                <div class="col-10 text-content text-white h-100 z-1 mb-5">
                    <!-- <div class="wrapimage"><img src="assets/img/tablet-atom.png" width="70%"></div> -->
                    <ul class="white wow slideInLeft">
                        <li>{{SectionBenefit.lists1}}</li>
                        <li>{{SectionBenefit.lists2}}</li>
                        <li>{{SectionBenefit.lists3}}</li>
                        <li>{{SectionBenefit.lists4}}</li>
                        <li>{{SectionBenefit.lists5}}</li>
                        <li>{{SectionBenefit.lists6}}</li>
                        <li>{{SectionBenefit.lists7}}</li>
                    </ul>
                </div>
                <div class="col-2">
                <div class="atomanimate position-relative px-3 py-5 my-1 wow slideInRight">
                        <div class="atom">
                            <div class="line line-1"></div>
                            <div class="line line-2"></div>
                            <div class="line line-3"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Benefit End -->
</template>

<script>
    import axios from 'axios'

export default {
  name: 'SectionBenefit',

  data(){
   return{
     lastScrollPosition: 0,
     SectionBenefit:{
         title: null,
         title2: null,
         lists1: null,
         lists2: null,
         lists3: null,
         lists4: null,
         lists5: null,
         lists6: null,
         lists7: null
         }
   }
 },

  mounted(){
    axios.get(`../../lang.json`).then(response => {
            let dataSectionBenefit
            if (localStorage.getItem('lang_nad') == 'id'){
                dataSectionBenefit= response.data.id[0];
            } else if(localStorage.getItem('lang_nad') == 'en'){
                dataSectionBenefit = response.data.en[0];
            }
            this.SectionBenefit.title = dataSectionBenefit.SectionBenefit.title
            this.SectionBenefit.title2 = dataSectionBenefit.SectionBenefit.title2
            this.SectionBenefit.lists1 = dataSectionBenefit.SectionBenefit.lists1
            this.SectionBenefit.lists2 = dataSectionBenefit.SectionBenefit.lists2
            this.SectionBenefit.lists3 = dataSectionBenefit.SectionBenefit.lists3
            this.SectionBenefit.lists4 = dataSectionBenefit.SectionBenefit.lists4
            this.SectionBenefit.lists5 = dataSectionBenefit.SectionBenefit.lists5
            this.SectionBenefit.lists6 = dataSectionBenefit.SectionBenefit.lists6
            this.SectionBenefit.lists7 = dataSectionBenefit.SectionBenefit.lists7
            })

    window.addEventListener('scroll', this.onScroll)
  }
}
</script>